import { heroEquipment } from "../HeroEquipment";

export const gladiatorzy = {
  heroes: {
    Mecenas: {
      id: 0,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Gladiatorzy z Jałowej Krainy"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Dowódca", "Handlarz niewolników"],
      exp: 20,
      skills: [0, 1, 2, 3, 4, 5],
    },
    Czarownik: {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Gladiatorzy z Jałowej Krainy"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Guślarstwo", "Mag (Kolegia Magii)"],
      exp: 12,
      skills: [2, 4, 5],
    },
    Czempion: {
      id: 2,
      startingEquipment: ["Sztylet", "Korbacz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Gladiatorzy z Jałowej Krainy"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mistrz miecza"],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    Felczer: {
      id: 4,
      startingEquipment: ["Sztylet"],
      cost: 15,
      number: 1,
      equipmentList: heroEquipment["Gladiatorzy z Jałowej Krainy"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 6],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Felczer"],
      exp: 8,
      skills: [0, 2, 5],
    },
    Treser: {
      id: 5,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Gladiatorzy z Jałowej Krainy"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Treser"],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    Niewolnik: {
      id: 6,
      startingEquipment: ["Broń improwizowana"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 2],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mięso armatnie", "Niewolnik", "Rozmiar rzondzi"],
    },
    Gladiator: {
      id: 7,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 30,
      number: 7,
      equipmentList: heroEquipment["Gladiatorzy z Jałowej Krainy"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Chorążowie & sygnaliści", "Drużyna obsługi", "Szermierz"],
    },
    Szablozębny: {
      id: 8,
      startingEquipment: ["Broń naturalna (precyzyjne uderzenie)"],
      cost: 70,
      number: 2,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [8, 4, 0, 4, 4, 2, 4, 2, 4],
        Maksymalna: [8, 4, 0, 4, 4, 2, 4, 2, 4],
      },
      rules: [
        "Duży cel",
        "Głód krwi",
        "Nienawiść",
        "Rączy",
        "Strach",
        "Zwiadowca",
        "Zwierzę",
      ],
    },
    "Pogromca trolli": {
      id: 9,
      startingEquipment: [
        "Topór krasnoludów",
        "Topór krasnoludów",
        "Broń wielka",
      ],
      cost: 50,
      number: 3,
      equipmentList: heroEquipment["Gladiatorzy z Jałowej Krainy"].Pogromca,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 10],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Fanatyk",
        "Krzepki",
        "Nieustępliwy",
        "Ochronne tatuaże",
        "Odporność na magię (2)",
        "Pogromca",
        "Rankor",
        "Topory pogromcy",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
    },
    Ogr: {
      id: 10,
      startingEquipment: ["Maczuga ogrów"],
      cost: 160,
      number: 1,
      equipmentList: heroEquipment["Gladiatorzy z Jałowej Krainy"].Ogr,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 2, 4, 4, 3, 2, 2, 7],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Oznakowany gnoblar (gnoblar-uwaga)",
        "Przepastne trzewia",
        "Strach",
        "Tempy",
        "Wielkolud",
      ],
    },
    Niedźwiedź: {
      id: 11,
      startingEquipment: ["Broń naturalna"],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 4, 0, 5, 4, 3, 4, 3, 6],
        Maksymalna: [6, 4, 0, 5, 4, 3, 4, 3, 6],
      },
      rules: ["Bestia", "Głód trzewi", "Potwór", "Zwiadowca", "Zwierzę"],
    },
    Nomada: {
      id: 12,
      startingEquipment: [
        "Sztylet",
        "Miecz",
        "Łuk krótki",
        "Koń bojowy",
        "Siodło & uprząż",
      ],
      cost: 80,
      number: 3,
      equipmentList: heroEquipment["Gladiatorzy z Jałowej Krainy"].Nomada,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 4, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
        "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Kawalerzysta", "Lekka jazda", "Ranger", "Zwiadowca"],
    },
    Więźniarka: {
      id: 13,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Więźniarka"],
    },
    Rydwan: {
      id: 14,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
  },
  limit: 600,
  minModels: 3,
  maxModels: 15,
  name: "Gladiatorzy z Jałowej Krainy",
  nature: "Neutralna",
  armyRules: ["Kontakty handlowe (3)", "Rozrzutność", "Zamożność"],
  mercenaries: [
    "Balistyk",
    "Bombardier",
    "Goniec",
    "Kartograf",
    "Kupiec",
    "Łowca nagród",
    "Magus",
    "Medyk",
    "Minstrel",
    "Miotacz ołowiu",
    "Ochroniarz",
    "Pogromca Trolli",
    "Poszukiwacz złota",
    "Rozbójnik",
    "Rycerz najemny",
    "Skryba",
    "Szczurołap",
    "Szpieg",
    "Tileański kusznik",
    "Trefniś",
    "Woźnica",
    "Wróżbita",
    "Złodziej",
    "Zwadźca",
    "Zwiadowca",
  ],
};
